import { platformRead } from './http'
export const queryFleetObserved = (data, options = {}) => platformRead({ method: 'post', url: '/jetlinks/visualization/fleet/_query', data }, options)
